import { Cryptocurrency } from '../constants/crypto.enum';

export const getDecimalScaleForCurrency = (currency: string) => {
  const isCryptocurrency = Object.values(Cryptocurrency).includes(
    currency as Cryptocurrency
  );

  if (isCryptocurrency) {
    return 5;
  }

  return 2;
};
